import { Button, Element, Container } from 'pcui';

import { Events } from '../../events';
import { localize } from '../localization';
import recSVG from '../svg/camera-panel.svg';
import markersSVG from '../svg/select-brush.svg';
import viewSVG from '../svg/view-mode.svg';
import { Tooltips } from '../tooltips';
// import cropSvg from './svg/crop.svg';

const createSvg = (svgString: string) => {
    const decodedStr = decodeURIComponent(svgString.substring('data:image/svg+xml,'.length));
    return new DOMParser().parseFromString(decodedStr, 'image/svg+xml').documentElement;
};

class BottomToolbarOHZ extends Container {
    constructor(events: Events, tooltips: Tooltips, args = {}) {
        args = {
            ...args,
            id: 'bottom-toolbar'
        };

        super(args);

        this.dom.addEventListener('pointerdown', (event) => {
            event.stopPropagation();
        });

        const viewMode = new Button({
            id: 'bottom-toolbar-view',
            class: 'bottom-toolbar-tool'
        });

        const markersMode = new Button({
            id: 'bottom-toolbar-markers',
            class: 'bottom-toolbar-tool'
        });

        const recMode = new Button({
            id: 'bottom-toolbar-rec',
            class: 'bottom-toolbar-tool'
        });

        viewMode.dom.appendChild(createSvg(viewSVG));
        this.append(viewMode);

        markersMode.dom.appendChild(createSvg(markersSVG));
        this.append(markersMode);

        recMode.dom.appendChild(createSvg(recSVG));
        this.append(recMode);

        // recMode.dom.addEventListener('click', () => events.fire('tool.rectSelection'));

        events.on('tool.activated', (toolName: string) => {
            recMode.class[toolName === 'rectSelection' ? 'add' : 'remove']('active');
            viewMode.class[toolName === 'view' ? 'add' : 'remove']('active');
            markersMode.class[toolName === 'markers' ? 'add' : 'remove']('active');
        });

        // register tooltips
        tooltips.register(recMode, localize('tooltip.recMode'));
        tooltips.register(viewMode, localize('tooltip.viewMode'));
        tooltips.register(markersMode, localize('tooltip.markersMode'));
    }
}

export { BottomToolbarOHZ };
